/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { DeleteMessage } from '../fn/tickets/delete-message';
import { DeleteMessage$Params } from '../fn/tickets/delete-message';
import { EditMessage } from '../fn/tickets/edit-message';
import { EditMessage$Params } from '../fn/tickets/edit-message';
import { Get } from '../fn/tickets/get';
import { Get$Params } from '../fn/tickets/get';
import { GetAttachmentData } from '../fn/tickets/get-attachment-data';
import { GetAttachmentData$Params } from '../fn/tickets/get-attachment-data';
import { GetAttachmentURL } from '../fn/tickets/get-attachment-url';
import { GetAttachmentURL$Params } from '../fn/tickets/get-attachment-url';
import { GetGitHubIssues } from '../fn/tickets/get-git-hub-issues';
import { GetGitHubIssues$Params } from '../fn/tickets/get-git-hub-issues';
import { GetSimiliarTickets } from '../fn/tickets/get-similiar-tickets';
import { GetSimiliarTickets$Params } from '../fn/tickets/get-similiar-tickets';
import { GetTicketFilterDropdowns } from '../fn/tickets/get-ticket-filter-dropdowns';
import { GetTicketFilterDropdowns$Params } from '../fn/tickets/get-ticket-filter-dropdowns';
import { GetTicketMetrics } from '../fn/tickets/get-ticket-metrics';
import { GetTicketMetrics$Params } from '../fn/tickets/get-ticket-metrics';
import { GetTickets } from '../fn/tickets/get-tickets';
import { GetTickets$Params } from '../fn/tickets/get-tickets';
import { GithubIssueViewModel } from '../models/github-issue-view-model';
import { LinkGitHubIssue } from '../fn/tickets/link-git-hub-issue';
import { LinkGitHubIssue$Params } from '../fn/tickets/link-git-hub-issue';
import { List } from '../fn/tickets/list';
import { List$Params } from '../fn/tickets/list';
import { SaveTicketAssignment } from '../fn/tickets/save-ticket-assignment';
import { SaveTicketAssignment$Params } from '../fn/tickets/save-ticket-assignment';
import { SaveTicketEffort } from '../fn/tickets/save-ticket-effort';
import { SaveTicketEffort$Params } from '../fn/tickets/save-ticket-effort';
import { SaveTicketPriority } from '../fn/tickets/save-ticket-priority';
import { SaveTicketPriority$Params } from '../fn/tickets/save-ticket-priority';
import { SaveTicketStatus } from '../fn/tickets/save-ticket-status';
import { SaveTicketStatus$Params } from '../fn/tickets/save-ticket-status';
import { SaveTicketType } from '../fn/tickets/save-ticket-type';
import { SaveTicketType$Params } from '../fn/tickets/save-ticket-type';
import { SendNewMessage } from '../fn/tickets/send-new-message';
import { SendNewMessage$Params } from '../fn/tickets/send-new-message';
import { SetClosed } from '../fn/tickets/set-closed';
import { SetClosed$Params } from '../fn/tickets/set-closed';
import { SetCritical } from '../fn/tickets/set-critical';
import { SetCritical$Params } from '../fn/tickets/set-critical';
import { SetMessageAdminView } from '../fn/tickets/set-message-admin-view';
import { SetMessageAdminView$Params } from '../fn/tickets/set-message-admin-view';
import { SetMessageRead } from '../fn/tickets/set-message-read';
import { SetMessageRead$Params } from '../fn/tickets/set-message-read';
import { SetParentTicket } from '../fn/tickets/set-parent-ticket';
import { SetParentTicket$Params } from '../fn/tickets/set-parent-ticket';
import { SetPinned } from '../fn/tickets/set-pinned';
import { SetPinned$Params } from '../fn/tickets/set-pinned';
import { SetTicketRead } from '../fn/tickets/set-ticket-read';
import { SetTicketRead$Params } from '../fn/tickets/set-ticket-read';
import { SupportTicketDropdowns } from '../models/support-ticket-dropdowns';
import { SupportTicketHomeViewModel } from '../models/support-ticket-home-view-model';
import { SupportTicketMessageViewModel } from '../models/support-ticket-message-view-model';
import { SupportTicketMetricsViewModel } from '../models/support-ticket-metrics-view-model';
import { SupportTicketSelectItem } from '../models/support-ticket-select-item';
import { SupportTicketSimilarTickets } from '../models/support-ticket-similar-tickets';
import { SupportTicketViewModel } from '../models/support-ticket-view-model';
import { SupportTicketViewModelPrimeDatatableResults } from '../models/support-ticket-view-model-prime-datatable-results';
import { UnmergeTickets } from '../fn/tickets/unmerge-tickets';
import { UnmergeTickets$Params } from '../fn/tickets/unmerge-tickets';

@Injectable({ providedIn: 'root' })
export class TicketsApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTicketsListPost()` */
  static readonly ApiTicketsListPostPath = '/api/Tickets/List';

  /**
   * ListSupport Tickets.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `List()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List$Response(params?: List$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketViewModelPrimeDatatableResults>> {
    return List(this.http, this.rootUrl, params, context);
  }

  /**
   * ListSupport Tickets.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `List$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  List(params?: List$Params, context?: HttpContext): Observable<SupportTicketViewModelPrimeDatatableResults> {
    return this.List$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketViewModelPrimeDatatableResults>): SupportTicketViewModelPrimeDatatableResults => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetTicketsPost()` */
  static readonly ApiTicketsGetTicketsPostPath = '/api/Tickets/GetTickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTickets()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GetTickets$Response(params?: GetTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketHomeViewModel>> {
    return GetTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTickets$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  GetTickets(params?: GetTickets$Params, context?: HttpContext): Observable<SupportTicketHomeViewModel> {
    return this.GetTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketHomeViewModel>): SupportTicketHomeViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetTicketFilterDropdownsGet()` */
  static readonly ApiTicketsGetTicketFilterDropdownsGetPath = '/api/Tickets/GetTicketFilterDropdowns';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTicketFilterDropdowns()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTicketFilterDropdowns$Response(params?: GetTicketFilterDropdowns$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketDropdowns>> {
    return GetTicketFilterDropdowns(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTicketFilterDropdowns$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTicketFilterDropdowns(params?: GetTicketFilterDropdowns$Params, context?: HttpContext): Observable<SupportTicketDropdowns> {
    return this.GetTicketFilterDropdowns$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketDropdowns>): SupportTicketDropdowns => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetTicketMetricsGet()` */
  static readonly ApiTicketsGetTicketMetricsGetPath = '/api/Tickets/GetTicketMetrics';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetTicketMetrics()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTicketMetrics$Response(params?: GetTicketMetrics$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMetricsViewModel>> {
    return GetTicketMetrics(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetTicketMetrics$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetTicketMetrics(params?: GetTicketMetrics$Params, context?: HttpContext): Observable<SupportTicketMetricsViewModel> {
    return this.GetTicketMetrics$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketMetricsViewModel>): SupportTicketMetricsViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetPost()` */
  static readonly ApiTicketsGetPostPath = '/api/Tickets/Get';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `Get()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get$Response(params?: Get$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketViewModel>> {
    return Get(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `Get$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  Get(params?: Get$Params, context?: HttpContext): Observable<SupportTicketViewModel> {
    return this.Get$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketViewModel>): SupportTicketViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetPinnedPost()` */
  static readonly ApiTicketsSetPinnedPostPath = '/api/Tickets/SetPinned';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetPinned()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetPinned$Response(params?: SetPinned$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetPinned(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetPinned$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetPinned(params?: SetPinned$Params, context?: HttpContext): Observable<boolean> {
    return this.SetPinned$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetClosedPost()` */
  static readonly ApiTicketsSetClosedPostPath = '/api/Tickets/SetClosed';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetClosed()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetClosed$Response(params?: SetClosed$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetClosed(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetClosed$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetClosed(params?: SetClosed$Params, context?: HttpContext): Observable<boolean> {
    return this.SetClosed$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetParentTicketPost()` */
  static readonly ApiTicketsSetParentTicketPostPath = '/api/Tickets/SetParentTicket';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetParentTicket()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetParentTicket$Response(params?: SetParentTicket$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketSelectItem>> {
    return SetParentTicket(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetParentTicket$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetParentTicket(params?: SetParentTicket$Params, context?: HttpContext): Observable<SupportTicketSelectItem> {
    return this.SetParentTicket$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketSelectItem>): SupportTicketSelectItem => r.body)
    );
  }

  /** Path part for operation `apiTicketsUnmergeTicketsPost()` */
  static readonly ApiTicketsUnmergeTicketsPostPath = '/api/Tickets/UnmergeTickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `UnmergeTickets()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UnmergeTickets$Response(params?: UnmergeTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketSelectItem>> {
    return UnmergeTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `UnmergeTickets$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  UnmergeTickets(params?: UnmergeTickets$Params, context?: HttpContext): Observable<SupportTicketSelectItem> {
    return this.UnmergeTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketSelectItem>): SupportTicketSelectItem => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetMessageAdminViewPost()` */
  static readonly ApiTicketsSetMessageAdminViewPostPath = '/api/Tickets/SetMessageAdminView';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetMessageAdminView()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetMessageAdminView$Response(params?: SetMessageAdminView$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetMessageAdminView(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetMessageAdminView$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetMessageAdminView(params?: SetMessageAdminView$Params, context?: HttpContext): Observable<boolean> {
    return this.SetMessageAdminView$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetMessageReadPost()` */
  static readonly ApiTicketsSetMessageReadPostPath = '/api/Tickets/SetMessageRead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetMessageRead()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetMessageRead$Response(params?: SetMessageRead$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetMessageRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetMessageRead$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetMessageRead(params?: SetMessageRead$Params, context?: HttpContext): Observable<boolean> {
    return this.SetMessageRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetTicketReadPost()` */
  static readonly ApiTicketsSetTicketReadPostPath = '/api/Tickets/SetTicketRead';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetTicketRead()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetTicketRead$Response(params?: SetTicketRead$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetTicketRead(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetTicketRead$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetTicketRead(params?: SetTicketRead$Params, context?: HttpContext): Observable<boolean> {
    return this.SetTicketRead$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSetCriticalPost()` */
  static readonly ApiTicketsSetCriticalPostPath = '/api/Tickets/SetCritical';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SetCritical()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetCritical$Response(params?: SetCritical$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SetCritical(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SetCritical$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SetCritical(params?: SetCritical$Params, context?: HttpContext): Observable<boolean> {
    return this.SetCritical$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSaveTicketTypePost()` */
  static readonly ApiTicketsSaveTicketTypePostPath = '/api/Tickets/SaveTicketType';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTicketType()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketType$Response(params?: SaveTicketType$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SaveTicketType(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTicketType$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketType(params?: SaveTicketType$Params, context?: HttpContext): Observable<boolean> {
    return this.SaveTicketType$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSaveTicketStatusPost()` */
  static readonly ApiTicketsSaveTicketStatusPostPath = '/api/Tickets/SaveTicketStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTicketStatus()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketStatus$Response(params?: SaveTicketStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SaveTicketStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTicketStatus$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketStatus(params?: SaveTicketStatus$Params, context?: HttpContext): Observable<boolean> {
    return this.SaveTicketStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSaveTicketPriorityPost()` */
  static readonly ApiTicketsSaveTicketPriorityPostPath = '/api/Tickets/SaveTicketPriority';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTicketPriority()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketPriority$Response(params?: SaveTicketPriority$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SaveTicketPriority(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTicketPriority$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketPriority(params?: SaveTicketPriority$Params, context?: HttpContext): Observable<boolean> {
    return this.SaveTicketPriority$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSaveTicketEffortPost()` */
  static readonly ApiTicketsSaveTicketEffortPostPath = '/api/Tickets/SaveTicketEffort';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTicketEffort()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketEffort$Response(params?: SaveTicketEffort$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SaveTicketEffort(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTicketEffort$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketEffort(params?: SaveTicketEffort$Params, context?: HttpContext): Observable<boolean> {
    return this.SaveTicketEffort$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsSaveTicketAssignmentPost()` */
  static readonly ApiTicketsSaveTicketAssignmentPostPath = '/api/Tickets/SaveTicketAssignment';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SaveTicketAssignment()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketAssignment$Response(params?: SaveTicketAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return SaveTicketAssignment(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SaveTicketAssignment$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SaveTicketAssignment(params?: SaveTicketAssignment$Params, context?: HttpContext): Observable<boolean> {
    return this.SaveTicketAssignment$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetSimiliarTicketsPost()` */
  static readonly ApiTicketsGetSimiliarTicketsPostPath = '/api/Tickets/GetSimiliarTickets';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetSimiliarTickets()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetSimiliarTickets$Response(params?: GetSimiliarTickets$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupportTicketSimilarTickets>>> {
    return GetSimiliarTickets(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetSimiliarTickets$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetSimiliarTickets(params?: GetSimiliarTickets$Params, context?: HttpContext): Observable<Array<SupportTicketSimilarTickets>> {
    return this.GetSimiliarTickets$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SupportTicketSimilarTickets>>): Array<SupportTicketSimilarTickets> => r.body)
    );
  }

  /** Path part for operation `apiTicketsLinkGitHubIssuePost()` */
  static readonly ApiTicketsLinkGitHubIssuePostPath = '/api/Tickets/LinkGitHubIssue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `LinkGitHubIssue()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkGitHubIssue$Response(params?: LinkGitHubIssue$Params, context?: HttpContext): Observable<StrictHttpResponse<GithubIssueViewModel>> {
    return LinkGitHubIssue(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `LinkGitHubIssue$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  LinkGitHubIssue(params?: LinkGitHubIssue$Params, context?: HttpContext): Observable<GithubIssueViewModel> {
    return this.LinkGitHubIssue$Response(params, context).pipe(
      map((r: StrictHttpResponse<GithubIssueViewModel>): GithubIssueViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetGitHubIssuesGet()` */
  static readonly ApiTicketsGetGitHubIssuesGetPath = '/api/Tickets/GetGitHubIssues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetGitHubIssues()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGitHubIssues$Response(params?: GetGitHubIssues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GithubIssueViewModel>>> {
    return GetGitHubIssues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetGitHubIssues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetGitHubIssues(params?: GetGitHubIssues$Params, context?: HttpContext): Observable<Array<GithubIssueViewModel>> {
    return this.GetGitHubIssues$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<GithubIssueViewModel>>): Array<GithubIssueViewModel> => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetAttachmentDataGet()` */
  static readonly ApiTicketsGetAttachmentDataGetPath = '/api/Tickets/GetAttachmentData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetAttachmentData()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAttachmentData$Response(params?: GetAttachmentData$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetAttachmentData(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetAttachmentData$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  GetAttachmentData(params?: GetAttachmentData$Params, context?: HttpContext): Observable<string> {
    return this.GetAttachmentData$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTicketsGetAttachmentUrlPost()` */
  static readonly ApiTicketsGetAttachmentUrlPostPath = '/api/Tickets/GetAttachmentURL';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `GetAttachmentURL()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetAttachmentURL$Response(params?: GetAttachmentURL$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return GetAttachmentURL(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `GetAttachmentURL$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  GetAttachmentURL(params?: GetAttachmentURL$Params, context?: HttpContext): Observable<string> {
    return this.GetAttachmentURL$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiTicketsSendNewMessagePost()` */
  static readonly ApiTicketsSendNewMessagePostPath = '/api/Tickets/SendNewMessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `SendNewMessage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SendNewMessage$Response(params?: SendNewMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMessageViewModel>> {
    return SendNewMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `SendNewMessage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  SendNewMessage(params?: SendNewMessage$Params, context?: HttpContext): Observable<SupportTicketMessageViewModel> {
    return this.SendNewMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketMessageViewModel>): SupportTicketMessageViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsEditMessagePost()` */
  static readonly ApiTicketsEditMessagePostPath = '/api/Tickets/EditMessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `EditMessage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  EditMessage$Response(params?: EditMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketMessageViewModel>> {
    return EditMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `EditMessage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  EditMessage(params?: EditMessage$Params, context?: HttpContext): Observable<SupportTicketMessageViewModel> {
    return this.EditMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<SupportTicketMessageViewModel>): SupportTicketMessageViewModel => r.body)
    );
  }

  /** Path part for operation `apiTicketsDeleteMessagePost()` */
  static readonly ApiTicketsDeleteMessagePostPath = '/api/Tickets/DeleteMessage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `DeleteMessage()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteMessage$Response(params?: DeleteMessage$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return DeleteMessage(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `DeleteMessage$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  DeleteMessage(params?: DeleteMessage$Params, context?: HttpContext): Observable<boolean> {
    return this.DeleteMessage$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
